// @ts-ignore
import CryptoJS  from 'crypto-js'

export const useCrypto = (password: any) => {
    const secret = "JY7ds06A5H4BT5L87Ijd"
    // @ts-ignore
    const result = CryptoJS.SHA256(password, secret).toString();
    return result;
}